module.exports = __webpack_public_path__ + "static/media/ROsanswebtextbold.3ce89faa.ttf";